var tokenTypes = {};
export {
  tokenTypes as __exports
};
//# sourceMappingURL=tokenTypes.js.map
